export default interface ITime {
	get(): Promise<IGetTime>;
	set(currentDate: Date, timezone: string): Promise<void>;
	setManual(currentDate: Date, timezone: string): Promise<void>;
	setManual(dateTime: DateTime, timezone: string): Promise<void>;
	setNTP(ntpServer: string, timezone: string): Promise<void>;
}

/**
 * All values are raw, none are zero-indexed.
 */
export interface DateTime {
	year: number;
	month: number;
	day: number;
	hour: number;
	minute: number;
	second: number;
}

export const VDateTime = {
	year: 'number',
	month: 'number',
	day: 'number',
	hour: 'number',
	minute: 'number',
	second: 'number',
};

export interface IGetTime {
	currentDate: Date;
	timezone?: string;
	ntpServer?: string;
}
